module.exports = __webpack_public_path__ + "img/platzhalter-chiba-kat.61c30ab9.jpg";